import { StyleSheet, css } from 'aphrodite';
import React from 'react';
import { formatDpName, graphColorsForEachAdTypes } from '../data/data';
import { AppHelper } from './AppHelper';
import moment from 'moment';
import { Helper } from '../common/helpers/Helper';
import { AppUiHelper } from './AppUiHelper';
import { VenueSummary } from '../components/VenueSummary';

export class GraphUiHelper {

  static getVenueInfo(current) {
    return (
      (
        <div className={css(Styles.venueColumn)}>
          <VenueSummary item={current} site={current.site} showNotRegistered={false} />
          <div>
            <span className={css(Styles.line2)}>{moment(current.period, 'YYYYMMDD').format('MMMM Do, YYYY')}</span>
          </div>
          {current.hf &&
            <div>
              <span className={css(Styles.line2)}>First Online at: {Helper.formatDate2({ utcTimestamp: current.hf, format: 'hh:mm a' })}</span>
            </div>
          }
          {(current.noOfhrsOnline !== undefined && current.noOfhrsOnline !== null) &&
            <div>
              {current.noOfhrsOnline && current.noOfhrsOnline > 0 ? AppUiHelper.chipGreen('ONLINE: ' + current.noOfhrsOnline + '/24 hours') : AppHelper.offlineStatus()}
            </div>
          }
        </div>
      )
    )
  }

  static getExchangesOverallData = (current, options = {}) => {
    if (!current) return null
    const dataMap = {}
    Object.keys(current).forEach(key => {
      if (key.startsWith('get_') || key.startsWith('lsd_') ||
        key.startsWith('pop_') || key.startsWith('err_') || key.startsWith('ads_') || key.startsWith('svd_')) {
        const [type, code] = key.split('_'); // e.g., 'get_AD' → ['get', 'AD']
        if (code === 'DT' || code === 'D1') return
        if (!dataMap[code]) {
          dataMap[code] = { get: 0, ads: 0, svd: 0, pop: 0, err: 0 };
        }
        if (type === 'get') dataMap[code].get = current[key];
        if (type === 'ads') dataMap[code].ads = current[key];
        if (type === 'pop') dataMap[code].pop = current[key];
        if (type === 'err') dataMap[code].err = current[key];
        if (type === 'svd' && options.showSvd) dataMap[code].svd = current[key];
      }
    });
    const sortedExchangeCodes = Object.keys(dataMap)
      .filter(code => code !== 'CMS')
      .sort((a, b) => a.localeCompare(b));
    return (
      <div className={css(Styles.statsContainer)}>
        {sortedExchangeCodes.map((code) => {
          const values = dataMap[code];
          return (
            <div key={code} className={css(Styles.statsInnerContainer)}>
              <div className={css(Styles.dpText)}>
                {formatDpName(code)}
              </div>
              <div className={css(Styles.statsValues)}>
                <span className={css(Styles.statsValueText)}>Exchange Get Ads: <span style={{ color: graphColorsForEachAdTypes.get, fontWeight: 500 }}>{AppHelper.formatNumberStats(values.get)}</span></span>
                <span className={css(Styles.statsValueText)}>Leased Ads: <span style={{ color: graphColorsForEachAdTypes.leased, fontWeight: 500 }}>{AppHelper.formatNumberStats(values.ads)}</span></span>
                {options.showSvd &&
                  <span className={css(Styles.statsValueText)}>Served Ads: <span style={{ color: graphColorsForEachAdTypes.leased, fontWeight: 500 }}>{AppHelper.formatNumberStats(values.svd)}</span></span>
                }
                <span className={css(Styles.statsValueText)}>PoPs: <span style={{ color: graphColorsForEachAdTypes.pop, fontWeight: 500 }}>{AppHelper.formatNumberStats(values.pop)}</span></span>
                <span className={css(Styles.statsValueText)}>Errors: <span style={{ color: graphColorsForEachAdTypes.error, fontWeight: 500 }}>{AppHelper.formatNumberStats(values.err)}</span></span>
              </div>
            </div>
          )
        })}
        {current.cmsPop !== undefined &&
          <div key={'CMS'} className={css(Styles.statsInnerContainer)}>
            <div className={css(Styles.dpText)}>
              {'CMS'}
            </div>
            <div className={css(Styles.statsValues)}>
              <span className={css(Styles.statsValueText)}>PoPs: <span style={{ color: '#020BC3', fontWeight: 500 }}>{AppHelper.formatNumberStats(current.cmsPop) || 0}</span></span>
            </div>
          </div>
        }
        {current.adapireqs !== undefined &&
          <div key={'Dolphin Ad API Calls'} className={css(Styles.statsInnerContainer)}>
            <div className={css(Styles.dpText)}>
              {'Dolphin Ad API Calls'}
            </div>
            <div className={css(Styles.statsValues)}>
              <span className={css(Styles.statsValueText)}>Get: <span style={{ color: '#020BC3', fontWeight: 500 }}>{AppHelper.formatNumberStats(current.adapireqs) || 0}</span></span>
            </div>
          </div>
        }
      </div>
    );
  }

  static renderCreativeStats = (current, options = {}) => {
    const droppedStats = [
      { key: 'dropped', label: 'Bitrate Exceeded' },
      { key: 'mediaErrorDropped', label: 'Media Error', value: (current.invalidBrDropped || 0) + (current.invalidSizeDropped || 0) },
      { key: 'maxDurDropped', label: 'Max Duration Exceeded' },
      { key: 'aiAnalysisPendingDropped', label: 'AI Analysis Pending' },
    ]
    const contentDroppedStats = options.showContentDropped
      ? [{ key: 'contentDropped', label: 'Blocked Content' }]
      : []
    const droppedColor = graphColorsForEachAdTypes.dropped || graphColorsForEachAdTypes.error

    return (
      <div className={css(Styles.statsContainer)}>
        <div className={css(Styles.statsInnerContainer2)}>
          <div className={css(Styles.statsValues)}>
            <span className={css(Styles.statsValueText)}>Leased Ads: <span style={{ color: graphColorsForEachAdTypes.get, fontWeight: 500 }}>{AppHelper.formatNumberStats(current.leased)}</span></span>
            <span className={css(Styles.statsValueText)}>Served Ads: <span style={{ color: graphColorsForEachAdTypes.leased, fontWeight: 500 }}>{AppHelper.formatNumberStats(current.served)}</span></span>
            {!options.hidePop &&
              <span className={css(Styles.statsValueText)}>PoPs: <span style={{ color: graphColorsForEachAdTypes.pop, fontWeight: 500 }}>{AppHelper.formatNumberStats(current.pop)}</span></span>
            }
            {options.showDropped &&
              <div className={css(Styles.droppedStatsGroup)}>
                <span className={css(Styles.droppedTitle)}>Dropped:</span>
                {droppedStats.concat(contentDroppedStats).map((stat) => (
                  <span key={stat.key} className={css(Styles.statsValueText)}>{stat.label}: <span style={{ color: droppedColor, fontWeight: 500 }}>{AppHelper.formatNumberStats(stat.value !== undefined ? stat.value : current[stat.key])}</span></span>
                ))}
              </div>
            }
          </div>
        </div>
      </div>
    );
  }

}
const Styles = StyleSheet.create({
  statsInnerContainer: {
    display: 'flex',
    gap: 15,
    borderBottom: '1px solid #d7d7d7b5',
    padding: '5px 0px',
    width: 'max-content'
  },
  statsInnerContainer2: {
    display: 'flex',
    padding: '5px 0px',
    width: 'max-content'
  },
  dpText: {
    fontWeight: 'bold',
    backgroundColor: '#f5f5f5',
    padding: '3px 6px',
    borderRadius: 4,
    minWidth: 20,
    textAlign: 'center'
  },
  statsValues: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap'
  },
  droppedStatsGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
    flexBasis: '100%'
  },
  droppedTitle: {
    fontWeight: 'bold'
  },
  statsValueText: {
    // fontWeight: 'bold',
    backgroundColor: '#f5f5f5',
    padding: '3px 6px',
    borderRadius: 4,
    minWidth: 20,
    textAlign: 'center'
  },
  venueColumn: {
    display: 'flex',
    gap: 7,
    flexDirection: 'column'
  },
  spanValue: {},
  storeNameText: {
    fontWeight: 'bolder',
    fontSize: '16px',
    color: '#121212'
  },
  line2: {
    fontSize: 12,
  },
  addressSpan: {
    color: '#575757',
    fontWeight: 600
  }
})


// WEBPACK FOOTER //
// ./src/helpers/GraphUiHelper.js